import { c as _c } from "react/compiler-runtime";
import { CodeBlock, Dialog, LinkButton } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
const IP_ADDRESSES = ['44.228.126.217', '50.112.21.217', '52.24.126.164', '54.148.139.208', '2600:1f24:64:8000::/56'];
const IpAllowlist = () => {
  const $ = _c(36);
  const {
    t
  } = useTranslation("webhooks");
  const [open, setOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = IP_ADDRESSES.join("\n");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const content = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpen(true);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <LinkButton onClick={t1}>{t2}</LinkButton>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp2);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpen(false);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp3);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setOpen(false);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = {
      label: t6,
      onClick: t7
    };
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t(_temp4);
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <p className="text-body-3 text-secondary">{t9}</p>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t) {
    t11 = t(_temp5);
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t(_temp6);
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <CodeBlock language="text" title={t11} ariaLabel={t12}>{content}</CodeBlock>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t10 || $[26] !== t13) {
    t14 = <div className="flex flex-col gap-4">{t10}{t13}</div>;
    $[25] = t10;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== open || $[29] !== t14 || $[30] !== t4 || $[31] !== t8) {
    t15 = <Dialog title={t4} size="compact" open={open} onClose={t5} primaryButton={t8}>{t14}</Dialog>;
    $[28] = open;
    $[29] = t14;
    $[30] = t4;
    $[31] = t8;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t15 || $[34] !== t3) {
    t16 = <>{t3}{t15}</>;
    $[33] = t15;
    $[34] = t3;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
};
export default IpAllowlist;
function _temp($) {
  return $.allowlist.buttonLabel;
}
function _temp2($_0) {
  return $_0.allowlist.title;
}
function _temp3($_1) {
  return $_1.allowlist.close;
}
function _temp4($_2) {
  return $_2.allowlist.subtitle;
}
function _temp5($_3) {
  return $_3.allowlist.addressesLabel;
}
function _temp6($_4) {
  return $_4.allowlist.copy;
}